theme.modalChart = function() {
  var ids = [];
  var buttons = document.querySelectorAll('.chart-modal-button');
  console.log
  if (!buttons.length) {
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('mouseover', productMouseover);
  });

  function productMouseover(evt) {
    var el = evt.currentTarget;
    el.removeEventListener('mouseover', productMouseover);
    // No quick view on mobile breakpoint
      if (!el || !el.dataset.productId) {
        // Onboarding product, no real data
        return;
      }
      var productId = el.dataset.productId;
      var modalId = 'QuickShopHolder-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  }
};
theme.hideFilter = function() {
  
  var sidebar = document.querySelector('#CollectionSidebar');
  if (sidebar) {
    var selectedFilterStatus = sessionStorage.getItem("filterStatus");
    var elementSidebar = document.querySelector('.grid__item--sidebar');
    var elementCollectionContainer = document.querySelector('#collection-container');
    var colProductGridItem = document.querySelectorAll('.col-product-grid-item');
    var elementFilterHide = document.querySelector('.filter-hide');
    var elementFilterShow = document.querySelector('.filter-show');
     //elementFilterHide.classList.toggle("active");    
     //
    if (!theme.config.bpSmall) {
      if (selectedFilterStatus == 1) {
        //colProductGridItem.classList.replace("medium-up--one-quarter", "medium-up--one-third");
        elementSidebar.classList.remove("hide");
        elementCollectionContainer.classList.add("medium-up--four-fifths");
        elementFilterShow.classList.remove("active");
        elementFilterHide.classList.add("active");  
        var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-quarter", "medium-up--one-third");
        }
      } else {      
        elementSidebar.classList.add("hide");
        elementCollectionContainer.classList.remove("medium-up--four-fifths");
        elementFilterHide.classList.remove("active");  
        elementFilterShow.classList.add("active");
        
        var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-third", "medium-up--one-quarter");
        }
      }
    }
  } 
    
}

theme.toogleSidebar = function() {
  /*var buttons = document.querySelectorAll('.hide-filters');
  if (!buttons.length) {
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('click', toogleSidebarFilters.bind(this));
  });  */

}

  function toogleSidebarFilters(evt) {
    var el = evt.currentTarget;
    // No toogle filters on mobile breakpoint
    if (!theme.config.bpSmall) {
      el.removeEventListener('onclick', toogleSidebarFilters.bind(this));

      var elementSidebar = document.querySelector('.grid__item--sidebar');
       elementSidebar.classList.toggle("hide");
      var elementFilterHide = document.querySelector('.filter-hide');
       elementFilterHide.classList.toggle("active");
      var elementFilterShow = document.querySelector('.filter-show');
       elementFilterShow.classList.toggle("active");
      var elementCollectionContainer = document.querySelector('#collection-container'); 
       elementCollectionContainer.classList.toggle("medium-up--four-fifths");

      var colProductGridItem = document.querySelectorAll('.col-product-grid-item');

       if (elementFilterShow.classList.contains("active")) {
        var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-third", "medium-up--one-quarter");
        }
         sessionStorage.setItem("filterStatus", 0);
       } else {
         var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-quarter", "medium-up--one-third");
        }
         sessionStorage.setItem("filterStatus", 1); 
       }
       AOS.refreshHard();
    }
}

function mobileFilterActive () {
  document.getElementsByClassName("grid__item--sidebar")[0].classList.remove("hide")
  document.getElementsByClassName("filter-show")[0].classList.remove("active")
  document.getElementsByClassName("filter-hide")[0].classList.add("active")
}

function toogleSidebarFilters(evt) {
    var el = evt.currentTarget;
    // No toogle filters on mobile breakpoint
    if (!theme.config.bpSmall) {
      el.removeEventListener('onclick', toogleSidebarFilters.bind(this));

      var elementSidebar = document.querySelector('.grid__item--sidebar');
       elementSidebar.classList.toggle("hide");
      var elementFilterHide = document.querySelector('.filter-hide');
       elementFilterHide.classList.toggle("active");
      var elementFilterShow = document.querySelector('.filter-show');
       elementFilterShow.classList.toggle("active");
      var elementCollectionContainer = document.querySelector('#collection-container'); 
       elementCollectionContainer.classList.toggle("medium-up--four-fifths");

      var colProductGridItem = document.querySelectorAll('.col-product-grid-item');

       if (elementFilterShow.classList.contains("active")) {
        var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-third", "medium-up--one-quarter");
        }
         sessionStorage.setItem("filterStatus", 0);
       } else {
         var i;
        for (i = 0; i < colProductGridItem.length; i++) {
          colProductGridItem[i].classList.replace("medium-up--one-quarter", "medium-up--one-third");
        }
         sessionStorage.setItem("filterStatus", 1); 
       }
       AOS.refreshHard();
    }
}

function DOMready(callback) {
  if (document.readyState != 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
}
function goBack() {
  window.history.back();
}

function iconsSlider () {
  const textWithIcons = new Flickity('.text-with-icons-new', {
    wrapAround: true,
    resize: true,
    cellAlign: 'left',
    prevNextButtons: false,
    groupCells: true
  });

  window.on('resize', theme.utils.debounce(300, function () {
    textWithIcons.resize();
  }.bind(this)));

}

DOMready(function(){
  theme.hideFilter();
  theme.toogleSidebar();
  theme.logosSlider.init();
  theme.modalChart();
  iconsSlider();
});


